module.exports = __webpack_public_path__ + "img/api-logo.1e1eaa52.png";